import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { ToastCustomService, ToastMessage } from '../../servicos/toast-custom.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-toast-custom',
  templateUrl: './toast-custom.component.html',
  styleUrls: ['./toast-custom.component.css']
})
export class ToastCustomComponent implements OnInit, OnDestroy {
  messages: ToastMessage[] = [];
  private subscription: Subscription;

  constructor(private toastService: ToastCustomService, private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.subscription = this.toastService.onMessage$.subscribe(message => {
      this.messages = [...this.messages, message];
      this.cdr.detectChanges();

      if (!message.sticky) {
        setTimeout(() => {
          this.remove(message.id);
        }, message.life || 3000);
      }
    });
  }

  remove(id: number) {
    this.messages = this.messages.filter(m => m.id !== id);
    this.cdr.detectChanges();
  }

  getIcon(severity: string) {
    switch (severity) {
      case 'success': return 'pi pi-check-circle';
      case 'error': return 'pi pi-times-circle';
      case 'info': return 'pi pi-info-circle';
      case 'warn': return 'pi pi-exclamation-triangle';
      default: return 'pi pi-info-circle';
    }
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
